import React from 'react';

const colors = {
  blue:   'bg-blue-100 text-blue-700',
  green:  'bg-green-100 text-green-700',
  red:    'bg-red-100 text-red-700',
  gray:   'bg-gray-100 text-gray-600',
  amber:  'bg-amber-100 text-amber-700',
  purple: 'bg-purple-100 text-purple-700',
  pink:   'bg-pink-100 text-pink-700',
  indigo: 'bg-indigo-100 text-indigo-700',
  cyan:   'bg-cyan-100 text-cyan-700',
};

const sizes = {
  xs: 'px-1.5 py-0.5 text-[10px]',
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
};

/**
 * Status chip / type tag.
 * @param {'blue'|'green'|'red'|'gray'|'amber'|'purple'|'pink'|'indigo'|'cyan'} [color]
 * @param {'xs'|'sm'|'md'} [size]
 */
export default function Badge({
  color = 'gray',
  size = 'sm',
  className = '',
  children,
}) {
  return (
    <span
      className={[
        'inline-flex items-center font-semibold rounded-full',
        colors[color] ?? colors.gray,
        sizes[size] ?? sizes.sm,
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}
